import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import newsData from "../data/noticias.js";

// Importar estilos do Swiper
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useNavigate } from "react-router-dom";

export const NewsSwiper = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const navigate = useNavigate();

  const slidesPerView = isMobile ? 1 : isTablet ? 2 : 3;

  return (
    <Box sx={{ position: "relative" }}>
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={16}
        slidesPerView={slidesPerView}
        navigation={{
          prevEl: ".news-swiper-button-prev",
          nextEl: ".news-swiper-button-next",
        }}
        pagination={{
          clickable: true,
          el: ".news-swiper-pagination",
        }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        loop={true}
        speed={600}
        style={{
          "--swiper-navigation-color": theme.palette.primary.main,
          "--swiper-pagination-color": theme.palette.primary.main,
          "--swiper-pagination-bullet-inactive-color": "#ccc",
          "--swiper-navigation-size": "20px",
        }}
      >
        {newsData.map((news) => (
          <SwiperSlide key={news.id}>
            <Card
              sx={{
                position: "relative",
                overflow: "hidden",
                borderRadius: 1.5,
                boxShadow: 2,
                height: isMobile ? "200px" : "220px",
              }}
            >
              <CardMedia
                component="img"
                height={isMobile ? "200" : "220"}
                image={news.image}
                alt={news.title}
                sx={{ objectFit: "cover" }}
              />
              <CardContent
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: "linear-gradient(transparent, rgba(0,0,0,0.9))",
                  color: "white",
                  p: 1.5,
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: "0.85rem", md: "0.95rem" },
                    lineHeight: 1.2,
                    mb: 1,
                    fontWeight: 500,
                    backgroundColor: "background.default",
                    color: "primary.main",
                    borderRadius: 1,
                  }}
                >
                  {news.title}
                </Typography>
                <Button
                  endIcon={<ArrowForward fontSize="small" />}
                  sx={{
                    color: "primary.main",
                    backgroundColor: "background.default",
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                    py: 0.3,
                    px: 1,
                    minWidth: "auto",
                    "&:hover": {
                      backgroundColor: "action.hover",
                    },
                  }}
                  onClick={() => navigate(news.link)}
                >
                  Leia mais
                </Button>
              </CardContent>
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Navegação Desktop */}
      {!isMobile && (
        <>
          <div
            className="news-swiper-button-prev"
            style={{
              position: "absolute",
              left: -40,
              top: "50%",
              transform: "translateY(-50%)",
              width: 35,
              height: 35,
              backgroundColor: "white",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              cursor: "pointer",
              zIndex: 10,
              color: theme.palette.primary.main,
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            ‹
          </div>
          <div
            className="news-swiper-button-next"
            style={{
              position: "absolute",
              right: -40,
              top: "50%",
              transform: "translateY(-50%)",
              width: 35,
              height: 35,
              backgroundColor: "white",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              cursor: "pointer",
              zIndex: 10,
              color: theme.palette.primary.main,
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            ›
          </div>
        </>
      )}

      {/* Paginação */}
      <div
        className="news-swiper-pagination"
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "16px",
          gap: "4px",
        }}
      />
    </Box>
  );
};
